<template>
  <svg viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="11.4287" y="15" width="5.71429" height="5.71429" :fill="fill" />
    <rect x="32.8569" y="15" width="5.71428" height="5.71429" :fill="fill" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M45.8333 4.16667H4.16667V45.8333H45.8333V4.16667ZM0 0V50H50V0H0Z"
      :fill="fill"
    />
    <path
      d="M33.5716 37.1427C33.5716 36.0171 33.3499 34.9025 32.9191 33.8626C32.4884 32.8226 31.857 31.8777 31.0611 31.0818C30.2651 30.2859 29.3202 29.6545 28.2803 29.2238C27.2403 28.793 26.1258 28.5713 25.0001 28.5713C23.8745 28.5713 22.7599 28.793 21.72 29.2238C20.6801 29.6545 19.7352 30.2859 18.9392 31.0818C18.1433 31.8777 17.5119 32.8226 17.0812 33.8626C16.6504 34.9025 16.4287 36.0171 16.4287 37.1427"
      :stroke="fill"
      stroke-width="5"
    />
  </svg>
</template>

<script>
export default {
  computed: {
    fill() {
      return this.$store.state.config.colors.headerColor;
    },
  },
};
</script>
